module.exports = __webpack_public_path__ + "img/hzjg4.4e8df7b1.png";